export const navigationItemType = {
    dropdown: 'dropDown',
    reguralLink: 'reguralLink',
    separator: 'separator',
    langSwitcher: 'langSwitcher',
    ctaButtons: 'ctaButtons',
};
